import React, { useState, useEffect, useRef } from 'react';

const FAKE_NAMES = [
  'Maria Silva', 'João Santos', 'Ana Costa', 'Pedro Oliveira', 'Carla Ferreira',
  'Roberto Lima', 'Fernanda Alves', 'Lucas Pereira', 'Juliana Rodrigues',
  'Marcos Souza', 'Patrícia Martins', 'Ricardo Barbosa', 'Sandra Nascimento',
  'André Carvalho', 'Lucia Mendes'
];

const PurchaseNotifications = () => {
  const [notification, setNotification] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const timers = useRef([]);

  useEffect(() => {
    const push = (fn, ms) => {
      const id = setTimeout(fn, ms);
      timers.current.push(id);
      return id;
    };

    const cycle = () => {
      const name = FAKE_NAMES[Math.floor(Math.random() * FAKE_NAMES.length)];
      const time = Math.floor(Math.random() * 8) + 1; // 1-8 min atrás

      setNotification({ id: Date.now(), name, time });
      setIsVisible(true);

      // Fica visível por ~4,5s
      push(() => setIsVisible(false), 4500);

      // Próxima notificação depois de um intervalo maior (menos intrusivo)
      const gap = 4500 + 6000 + Math.random() * 5000; // ~10,5s a 15,5s
      push(cycle, gap);
    };

    // Pequeno atraso inicial para não aparecer logo de cara
    push(cycle, 3000);

    return () => {
      timers.current.forEach(clearTimeout);
      timers.current = [];
    };
  }, []);

  const formatTime = (minutes) =>
    minutes === 1 ? 'há 1 minuto' : `há ${minutes} minutos`;

  if (!notification) return null;

  return (
    <div className={`mgs-toast ${isVisible ? 'is-visible' : 'is-hidden'}`} role="status" aria-live="polite">
      <div className="mgs-toast__avatar">
        {notification.name.charAt(0)}
        <span className="mgs-toast__check">
          <i className="fas fa-check"></i>
        </span>
      </div>
      <div className="mgs-toast__body">
        <p className="mgs-toast__name">{notification.name}</p>
        <p className="mgs-toast__text">
          acabou de comprar o <strong>Magrisim</strong>
        </p>
        <p className="mgs-toast__time">
          <i className="far fa-clock"></i> {formatTime(notification.time)}
        </p>
      </div>
    </div>
  );
};

export default PurchaseNotifications;
